<!--*
 * Modal to show how to use the application
 *
 * @author   mauricio.figueroa
 * @date     2024-16-01
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <transition v-if="show" name="modal">
    <div class="modal-mask" @click="handleClickOutside">
      <div class="modal-wrapper" style="padding: 10px">
        <div class="modal-container" :style="{ width }">
          <div class="modal-header">
            <span v-if="title" class="modal-title">{{ title }}</span>
            <slot name="header"></slot>
            <app-button
                v-if="showClose"
                class="modal-close-button ml-auto"
                btn-type="ghost"
                icon="close"
                layout="icon"
                @click="$emit('on-close-click')"
            ></app-button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import AppButton from '@/components/AppButton';

export default {
  'name': 'AppModal',
  'components': { AppButton },
  'props': {
    'title': String,
    'show': {
      'type': Boolean,
      'default': false
    },
    'showClose': {
      'type': Boolean,
      'default': true
    },
    'width': {
      'type': String,
      'default': "600px"
    }
  },
  'methods': {
    handleClickOutside(e) {
      if (["modal-mask", "modal-wrapper"].includes((e.target).className)) {
        this.$emit("on-click-outside");
      }
    }
  }
}

</script>

<style scoped>
.modal-container {
  z-index: 9999;
  position: relative;
  min-height: 192px;
  margin: 30px auto;
  background-color: #FFFFFF;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px #E0E0E0;
  transition: all 0.3s ease;
  max-height: 95vh;
  overflow-y: auto;
  overflow-wrap: break-word;
}

.modal-header {
  padding: 0 40px;
  background-color: #FAFAFA;
}

.modal-title {
  font-size: 24px;
  font-weight: bold;
  margin: 16px 0;
}

.modal-body {
  padding: 32px 40px;
}

.modal-close-button {
  margin: 12px -16px 12px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
